import { Cart, SinglePosition } from "../types/Cart";

export const COUPON_ARTIKELTYP = "COUP";

export const isDiscounted = (position: SinglePosition): boolean =>
    position.grossPrice.value !== position.linePrice.value;

export const isUnappliedCoupon = (position: SinglePosition): boolean =>
    position.product.artikeltyp === COUPON_ARTIKELTYP &&
    !position.isDeleted &&
    !isDiscounted(position);

export const hasUnappliedCoupon = (cart: Cart): boolean =>
    cart.positions.some(
        (position) => position.kind === "single" && isUnappliedCoupon(position)
    );
